export const VisionProductWarning = () => {
    return (
        <div className="vision-product-msg">
            <i className="fas fa-exclamation-triangle icon" /> Plan provides{" "}
            <span className="form-label text-uppercase">either</span> contacts or lenses & frames,{" "}
            <span className="form-label text-uppercase">but not both</span> in any plan period
        </div>
    );
};
